module.exports = __webpack_public_path__ + "media/homepage/builder-hero@3x-21f69d97.png";